// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export const DEFAULT_API_VERSION = "2018-01-01";
export const DEFAULT_EVENTGRID_SCOPE = "https://eventgrid.azure.net/.default";
